if (!customElements.get('image-text-slider')) {
  class ImageTextSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.initSlider(this.querySelector('.image-text-block-swiper'));
        });
      }

      this.initSlider(this.querySelector('.image-text-block-swiper'));

      this.slider?.on('slideChange', e => {
        // const sliderIndex = e.realIndex;
        // document.querySelector(`.video-step-button[data-index="${sliderIndex}"]`).click();
      });

    }

    connectedCallback() {}
    
    initSlider(elem = this) {
      this.slider = new Swiper(elem, {
        spaceBetween: 10,
        slidesPerView: 1.1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: elem.dataset.itemsPerRow,
            spaceBetween: elem.dataset.spaceBetween
          }
        }
      })
    }
  }

  customElements.define('image-text-slider', ImageTextSlider);
}
